import { ColorIdToName } from "common/materials/library/colorIdToName";
import { LayerConfigIdToName } from "common/materials/library/layerConfigIdToName";
import { TemplateIdToName } from "common/materials/library/templateIdToName";
import type { MaterialSrc } from "common/materials/materialSrc";

const fallbackMaterialPath = "OUTDATED_MATERIAL.Default";

function materialPathFromMaterialSrc(materialSrc: MaterialSrc, includeColorName: boolean): string {
  const templateIdRecord = TemplateIdToName as Record<number, string>;
  const templateName = templateIdRecord[materialSrc.templateId];

  if (templateName === undefined) {
    return fallbackMaterialPath;
  }

  // Null values in LayerConfigIdToName indicate that the layer config is not in
  // any library, so we cannot emit a full layer-config path in that case.
  if (materialSrc.layerConfigId !== undefined && LayerConfigIdToName[materialSrc.layerConfigId] !== null) {
    const layerConfigName = LayerConfigIdToName[materialSrc.layerConfigId];
    if (layerConfigName !== undefined) {
      return `${templateName}.L.${layerConfigName}`;
    }
    return fallbackMaterialPath;
  }

  if (materialSrc.colorId !== undefined) {
    if (!includeColorName) {
      return `${templateName}.C`;
    }

    const colorName = ColorIdToName[materialSrc.colorId];
    if (colorName !== undefined) {
      return `${templateName}.C.${colorName}`;
    }
    return fallbackMaterialPath;
  }

  return `${templateName}.Default`;
}

export function pathStringFromMaterialSrc(materialSrc: MaterialSrc): string {
  return materialPathFromMaterialSrc(materialSrc, true);
}

export function pathStringFromMaterialSrcNoColor(materialSrc: MaterialSrc): string {
  return materialPathFromMaterialSrc(materialSrc, false);
}

export function pathStringFromMaterialSrcWithUserDefinedName(materialSrc: MaterialSrc): string {
  if (materialSrc?.userDefinedName) {
    return materialSrc.userDefinedName;
  }

  return pathStringFromMaterialSrc(materialSrc);
}
